module.exports = __webpack_public_path__ + "static/media/panCakeSwap.f26cf378.png";